export const NAMESPACE = 'CREATEORGANIZATION'